const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const TemplateActions = Reflux.createActions({
    createTemplate: { children: ['completed', 'failed'] },
    updateTemplate: { children: ['completed', 'failed'] },
    deleteTemplate: { children: ['completed', 'failed'] }
});

TemplateActions.createTemplate.listen(function(actionId) {
    const self = this;

    ServerRequest.makeRequest('/authoring/templates/create', 'POST')
        .then(function(res) { self.completed(actionId, res); })
        .catch(function(err) { self.failed(actionId, err); });
});

TemplateActions.updateTemplate.listen(function(actionId, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if (!params.displayName) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('displayName');
    }

    if (!params.asDisplayName) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('asDisplayName');
    }

    if (!params.moduleId) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('moduleId');
    }

    if (!params.product) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('product');
    }

    if (!params.templateUrl) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('templateUrl');
    }

    if (!params.editorUrl) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('editorUrl');
    }

    if (!params.icon) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('icon');
    }

    if (!params.noChangesIcon) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('noChangesIcon');
    }

    if (!params.unpublishedChangesIcon) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('unpublishedChangesIcon');
    }

    if (!params.createInfo) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('createInfo');
    }

    if (!valid) {
        this.failed(actionId, new ForgeError({ message: errorMsg, uiRefs: errorUIRefs }));
        return;
    }

    const templateId = params.templateId;
    delete params.templateId;

    const tmplUpdate = {
        name: params.displayName,
        as_display_name: params.asDisplayName,
        module_id: params.moduleId,
        product: params.product,
        template_url: params.templateUrl,
        editor_url: params.editorUrl,
        public: params.public,
        allow_assignment_qla: params.allowAssignmentQla,
        allow_multi_assign: params.allowMultiAssign,
        icon: params.icon,
        no_changes_icon: params.noChangesIcon,
        unpublished_changes_icon: params.unpublishedChangesIcon,
        create_info: params.createInfo
    };

    ServerRequest.makeRequest(`/authoring/templates/${templateId}`, 'PUT', JSON.stringify(tmplUpdate))
        .then(function(res) { self.completed(actionId, res); })
        .catch(function(err) { self.failed(actionId, err); });
});

TemplateActions.deleteTemplate.listen(function(params) {
    const self = this;

    if (!params.templateID) {
        return;
    }

    ServerRequest.makeRequest(`/authoring/templates/${params.templateID}`, 'DELETE')
        .then(self.completed)
        .catch(self.failed);
});

module.exports = TemplateActions;